import { PickerOption } from '../store/schema/CompositePickerInterfaces';
import CompositePickerStore from '../store/schema/CompositePickerStore';
import { action } from 'satcheljs';

export const updateSelectedOption = action(
    'updateSelectedOption',
    (viewState: CompositePickerStore, selectedOption: PickerOption) => ({
        viewState,
        selectedOption,
    })
);

export const updateTextFieldValue = action(
    'updateTextFieldValue',
    (viewState: CompositePickerStore, textFieldValue: string) => ({
        viewState,
        textFieldValue,
    })
);

export const updateNavIndex = action(
    'updateNavIndex',
    (viewState: CompositePickerStore, navIndex: number) => ({ viewState, navIndex })
);

export const onOptionSelected = action(
    'onOptionSelected',
    (
        viewState: CompositePickerStore,
        formatFunction: (option: PickerOption) => string,
        selectedOption: PickerOption
    ) => ({
        viewState,
        formatFunction,
        selectedOption,
    })
);
